import { ref, computed } from 'vue';

const isPageLoading = ref(false);
const pageLoadingMessage = ref('');

const localLoadingStates = ref(new Map());

export function useEnhancedLoading(componentId = null) {
    const showPageLoading = (message = '') => {
        isPageLoading.value = true;
        pageLoadingMessage.value = message;
    };

    const hidePageLoading = () => {
        isPageLoading.value = false;
        pageLoadingMessage.value = '';
    };
    const isLocalLoading = computed(() => {
        if (!componentId) return false;
        return localLoadingStates.value.get(componentId) || false;
    });

    const showLocalLoading = (id = componentId) => {
        if (!id) return;
        localLoadingStates.value.set(id, true);
        localLoadingStates.value = new Map(localLoadingStates.value);
    };

    const hideLocalLoading = (id = componentId) => {
        if (!id) return;
        localLoadingStates.value.delete(id);
        localLoadingStates.value = new Map(localLoadingStates.value);
    };

    const withPageLoading = async (asyncFn, message = '') => {
        try {
            showPageLoading(message);
            const result = await asyncFn();
            return result;
        } finally {
            hidePageLoading();
        }
    };

    const withLocalLoading = async (asyncFn, id = componentId) => {
        try {
            showLocalLoading(id);
            const result = await asyncFn();
            return result;
        } finally {
            hideLocalLoading(id);
        }
    };

    const createAbortController = () => {
        return new AbortController();
    };

    return {
        isPageLoading,
        pageLoadingMessage,
        showPageLoading,
        hidePageLoading,
        withPageLoading,

        isLocalLoading,
        showLocalLoading,
        hideLocalLoading,
        withLocalLoading,

        createAbortController
    };
}
